<template>
	<div class="modal fade show" tabindex="-1" role="dialog" style="display: block; background: rgba(0, 0, 0, 0.5);">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h5 class="modal-title">{{ notaSpesa ? 'Modifica Nota Spesa' : 'Nuova Nota Spesa' }}</h5>
					<button type="button" class="btn-close btn-close-white" @click="close()"></button>
				</div>

				<div class="modal-body">
					<form v-if="!notaSpesa || !showUpload" @submit.prevent="salvaSpesa(false)">
						<div class="row">
							<div class="col-4 mb-2">
								<label class="form-label">Utente</label>
								<select v-model="form.FK_ID_UTENTE" class="form-control" required>
									<option value="">Seleziona...</option>
									<option v-for="u in $root.arrayUtentiAdmin" :key="u.ID_UTENTE" :value="u.ID_UTENTE">
										{{ u.USERNAME }}
									</option>
								</select>
								<small class="text-muted d-block mt-1" v-if="form.FK_ID_UTENTE && dataLimite">
									Data limite: <strong>{{ formatData(dataLimite) }}</strong>
								</small>
								<small class="text-danger d-block mt-1" v-if="form.FK_ID_UTENTE && !dataLimite">
									Primo inserimento per questo utente
								</small>
							</div>

							<div class="col-3 mb-2">
								<label class="form-label">Data *</label>
								<Datepicker
									v-model="form.DATA"
									placeholder="Seleziona data"
									:formats="{ input: 'dd/MM/yyyy' }"
									:class="{ 'is-invalid': dataWarning }"
									auto-apply
									@update:model-value="checkDataWarning"
								/>
								<div class="invalid-feedback d-block" v-if="dataWarning">
									Attenzione: data uguale o precedente al limite ({{ formatData(dataLimite) }})
								</div>
							</div>

							<div class="col-2 mb-2">
								<label class="form-label">Importo *</label>
								<input
									type="number"
									v-model.number="form.IMPORTO"
									step="0.01"
									min="0"
									class="form-control"
									placeholder="0.00"
									required
								/>
							</div>

							<div class="col-3 mb-2">
								<label class="form-label">Tipo *</label>
								<select v-model.number="form.TIPO_MOVIMENTO" class="form-control" required>
									<option :value="0">Addebito (uscita)</option>
									<option :value="1">Accredito (entrata)</option>
								</select>
							</div>
						</div>

						<div class="row">
							<div class="col-3 mb-2">
								<label class="form-label">Categoria</label>
								<select v-model="form.FK_ID_CATEGORIA" class="form-control">
									<option value="">Nessuna</option>
									<option v-for="c in arrayCategorieSpese" :key="c.ID_OPZIONE_TIPOLOGICA" :value="c.ICONA">
										{{ c.DESCRIZIONE }}
									</option>
								</select>
							</div>
							<div class="col-9 mb-2">
								<label class="form-label">Descrizione *</label>
								<textarea
									v-model="form.DESCRIZIONE"
									class="form-control"
									rows="1"
									placeholder="es. Ristorante, Hotel, Trasporto..."
									required
								></textarea>
							</div>
						</div>

						<div v-if="message" class="alert" :class="messageClass" role="alert">
							{{ message }}
						</div>

						<div class="modal-footer">
							<button type="button" class="btn btn-sm btn-link" @click="close()">Annulla</button>
							<button type="submit" class="btn btn-sm btn-secondary" :disabled="loading">
								<i class="ph-check me-1"></i>Salva e chiudi
							</button>
							<button v-if="!notaSpesa" type="button" class="btn btn-sm btn-primary" :disabled="loading" @click="salvaSpesa(true)">
								<i class="ph-check me-1"></i>Salva e continua
							</button>
						</div>
					</form>

					<div v-if="notaSpesa || showUpload" class="mt-3">
						<p class="mb-3" v-if="!notaSpesa">Nota spesa salvata. Associa a un progetto e/o carica un allegato.</p>
						<div class="mb-3" v-if="!notaSpesa">
							<label class="form-label">Associa al progetto (opzionale)</label>
							<select v-model="selectedProgetto" class="form-control" :disabled="loadingProgetti">
								<option value="">Nessun progetto</option>
								<option v-for="p in arrayProgetti" :key="p.ID_PROGETTO" :value="p.ID_PROGETTO">
									{{ p.TITOLO }}
								</option>
							</select>
						</div>
						<div class="row mb-3" style="align-items: stretch;">
							<div class="col-md-6 d-flex flex-column">
								<label class="form-label text-center">Allegato</label>
								<div style="flex: 1;">
									<Upload
										url="core/basic/upload"
										:args="{ modalita: 'THEB_uploadAllegatoSpesa', ID_NOTA_SPESA: savedNotaId || notaSpesa.ID_NOTA_SPESA }"
										@onsuccess="onUploadSuccess"
										@onerror="onUploadError"
									/>
								</div>
							</div>
							<div class="col-md-6 d-flex flex-column" v-if="allegato">
								<label class="form-label text-center">Anteprima</label>
								<div class="card" style="flex: 1; margin-top: 20px;">
									<div class="card-body text-center">
										<img v-if="allegato.isImmagine" :src="allegato.url" :alt="allegato.nome" style="max-width: 100%; max-height: 300px; margin-bottom: 10px;">
										<div v-else-if="allegato.isPdf">
											<i class="fas fa-file-pdf" style="font-size: 50px; color: #d32f2f;"></i>
										</div>
										<p class="small mt-2 text-muted">{{ allegato.nome }}</p>
										<button v-if="allegato.isPdf" @click="openAllegato()" class="btn btn-sm btn-primary mt-2">
											<i class="fas fa-external-link-alt me-1"></i>Apri PDF
										</button>
									</div>
								</div>
							</div>
						</div>
						<div v-if="!notaSpesa" class="modal-footer mt-3">
							<button type="button" class="btn btn-sm btn-link" @click="skipUpload">Chiudi senza associare</button>
							<button type="button" class="btn btn-sm btn-primary" @click="associaEChiudi" :disabled="!selectedProgetto || loading">
								<i class="ph-check me-1"></i>Associa al progetto
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Upload from './utils/Upload.vue';
import { VueDatePicker as Datepicker } from '@vuepic/vue-datepicker';

export default {
	name: 'ModalNuovaSpesa',
	components: {
		Upload,
		Datepicker
	},
	props: {
		defaultIdProgetto: { type: [Number, String], default: null },
		notaSpesa: { type: Object, default: null }
	},
	data() {
		return {
			form: {
				FK_ID_UTENTE: '',
				DATA: '',
				IMPORTO: '',
				DESCRIZIONE: '',
				FK_ID_PROGETTO: this.defaultIdProgetto || '',
				FLG_ATTIVO: 1,
				TIPO_MOVIMENTO: 0,
				FK_ID_CATEGORIA: ''
			},
			dataLimite: null,
			dataWarning: false,
			message: '',
			messageClass: '',
			loading: false,
			savedNotaId: null,
			showUpload: false,
			allegato: null,
			allegatoRawPath: null,
			arrayCategorieSpese: [],
			arrayProgetti: [],
			selectedProgetto: '',
			loadingProgetti: false,
			filters: global.filters
		};
	},
	watch: {
		'form.FK_ID_UTENTE': function(newVal) {
			if (newVal) {
				this.getDataLimite();
			} else {
				this.dataLimite = null;
			}
		},
		notaSpesa: {
			immediate: true,
			handler(nota) {
				if (nota) {
					// Edit mode: pre-fill form
					this.form = {
						FK_ID_UTENTE: nota.FK_ID_UTENTE,
						DATA: nota.DATA,
						IMPORTO: nota.IMPORTO,
						DESCRIZIONE: nota.DESCRIZIONE,
						FK_ID_PROGETTO: nota.FK_ID_PROGETTO || this.defaultIdProgetto || '',
						FLG_ATTIVO: nota.FLG_ATTIVO,
						TIPO_MOVIMENTO: nota.TIPO_MOVIMENTO ?? 0,
						FK_ID_CATEGORIA: nota.FK_ID_CATEGORIA || ''
					};
					if (nota.FK_ID_UTENTE) {
						this.getDataLimite();
					}
					if (nota.FILE_ALLEGATO) {
						const filePath = nota.FILE_ALLEGATO;
						const fileName = filePath.split(/[\\/]/).pop() || 'Allegato';
						const isPdf = filePath.toLowerCase().endsWith('.pdf');
						const isImmagine = /\.(jpg|jpeg|png|gif|webp)$/i.test(filePath);
						this.allegato = { nome: fileName, url: this.getAllegatoPath(filePath), isPdf, isImmagine };
						this.allegatoRawPath = filePath;
					} else {
						this.allegato = null;
						this.allegatoRawPath = null;
					}
				} else {
					// Create mode: reset form
					this.form = {
						FK_ID_UTENTE: '',
						DATA: '',
						IMPORTO: '',
						DESCRIZIONE: '',
						FK_ID_PROGETTO: this.defaultIdProgetto || '',
						FLG_ATTIVO: 1,
							TIPO_MOVIMENTO: 0,
							FK_ID_CATEGORIA: ''
						};
					this.dataLimite = null;
					this.allegato = null;
				}
				this.message = '';
				this.messageClass = '';
				this.savedNotaId = null;
				this.showUpload = false;
			}
		}
	},
	created() {
		utils.ajax('shared/tipologiche', { FK_ID_MODULO: 63 }, (res) => {
			if (res.esito == 0 && res.data.length > 0) {
				utils.ajax('shared/tipologica', { ID_TIPOLOGICA: res.data[0].ID_TIPOLOGICA }, (res2) => {
					if (res2.esito == 0) this.arrayCategorieSpese = res2.data.opzioni || [];
				});
			}
		});
		this.loadingProgetti = true;
		utils.ajax('theb/progetti', {}, (res) => {
			if (res.esito == 0) this.arrayProgetti = res.data || [];
			this.loadingProgetti = false;
		});
	},
	methods: {
		getAllegatoPath(filePath) {
			if (!filePath) return '';
			const baseUpload = utils.BASE_API + '../../../../thebproject/UPLOAD/';
			return baseUpload + filePath.replace(/\\/g, '/');
		},
		openAllegato() {
			if (this.notaSpesa) {
				window.open(utils.BASE_API + 'theb/notaspesa/allegato?ID_NOTA_SPESA=' + this.notaSpesa.ID_NOTA_SPESA, '_blank');
			} else if (this.savedNotaId) {
				window.open(utils.BASE_API + 'theb/notaspesa/allegato?ID_NOTA_SPESA=' + this.savedNotaId, '_blank');
			}
		},
		getDataLimite() {
			utils.ajax('theb/notespese/data-limite', {
				FK_ID_UTENTE: this.form.FK_ID_UTENTE
			}, (res) => {
				if (res.esito == 0) {
					this.dataLimite = res.data || null;
				}
			});
		},
		checkDataWarning() {
			if (this.dataLimite && this.form.DATA) {
				const date = this.form.DATA instanceof Date ? this.form.DATA : new Date(this.form.DATA);
				const selectedDate = date.getTime();
				const limiteDate = new Date(this.dataLimite).getTime();
				this.dataWarning = selectedDate <= limiteDate;
			} else {
				this.dataWarning = false;
			}
		},
		salvaSpesa(continua = false) {
			if (this.dataWarning && !this.notaSpesa) {
				this.message = 'La data non può essere uguale o precedente al limite. Operazione bloccata.';
				this.messageClass = 'alert-danger';
				return;
			}

			this.loading = true;
			this.message = '';

			const payload = {
				FK_ID_UTENTE: this.form.FK_ID_UTENTE,
				DATA: this.filters.formatDateOnly(this.form.DATA),
				IMPORTO: this.form.IMPORTO,
				DESCRIZIONE: this.form.DESCRIZIONE,
				FK_ID_PROGETTO: this.form.FK_ID_PROGETTO || null,
				FLG_ATTIVO: this.form.FLG_ATTIVO,
				DATA_ADD: this.notaSpesa ? this.notaSpesa.DATA_ADD : new Date().toISOString().split('T')[0],
				FILE_ALLEGATO: this.allegatoRawPath ?? (this.notaSpesa ? this.notaSpesa.FILE_ALLEGATO : null),
				TIPO_MOVIMENTO: this.form.TIPO_MOVIMENTO,
				FK_ID_CATEGORIA: this.form.FK_ID_CATEGORIA || null
			};

			if (this.notaSpesa) {
				payload.ID_NOTA_SPESA = this.notaSpesa.ID_NOTA_SPESA;
			}

			const endpoint = this.notaSpesa ? 'theb/notaspesa/update' : 'theb/notaspesa/insert';

			utils.ajax(endpoint, payload, (res) => {
				this.loading = false;
				if (res.esito == 0) {
					const notaId = this.notaSpesa ? this.notaSpesa.ID_NOTA_SPESA : res.data.ID_NOTA_SPESA;
					this.savedNotaId = notaId;
					utils.notifiche.invia(this, endpoint == 'theb/notaspesa/insert' ? 'NOTA_SPESA_CREA' : 'NOTA_SPESA_MODIFICA', endpoint == 'theb/notaspesa/insert' ? 'ha creato una nota spesa' : 'ha modificato una nota spesa');
					if (this.notaSpesa) {
						this.$emit('saved');
					}

					if (continua) {
						const prevUtente = this.form.FK_ID_UTENTE;
						this.form = {
							FK_ID_UTENTE: prevUtente,
							DATA: '',
							IMPORTO: '',
							DESCRIZIONE: '',
							FK_ID_PROGETTO: this.defaultIdProgetto || '',
							FLG_ATTIVO: 1,
							TIPO_MOVIMENTO: 0,
							FK_ID_CATEGORIA: ''
						};
						this.allegato = null;
						this.allegatoRawPath = null;
						this.savedNotaId = null;
						this.showUpload = false;
						this.dataWarning = false;
						this.message = '';
						if (prevUtente) this.getDataLimite();
						utils.alert.success('Nota spesa salvata');
					} else {
						this.showUpload = true;
					}
				} else {
					this.message = res.messaggio || 'Errore nel salvataggio';
					this.messageClass = 'alert-danger';
				}
			});
		},
		onUploadSuccess(res) {
			// Estrai il file path dalla risposta
			const filePath = res.data?.file_path || res.file_path || '';
			const fileName = filePath.split('\\').pop() || 'Allegato';

			// Determina il tipo di file
			const isPdf = filePath.toLowerCase().endsWith('.pdf');
			const isImmagine = /\.(jpg|jpeg|png|gif|webp)$/i.test(filePath);

			// Salva le info dell'allegato
			this.allegato = {
				nome: fileName,
				url: this.getAllegatoPath(filePath),
				isPdf,
				isImmagine
			};

			this.allegatoRawPath = filePath;

			utils.alert.success('Allegato caricato');
		},
		onUploadError() {
			utils.alert.warning('Errore upload allegato');
			this.close();
		},
		associaEChiudi() {
			if (!this.selectedProgetto) return;
			this.loading = true;
			const payload = {
				ID_NOTA_SPESA: this.savedNotaId,
				FK_ID_UTENTE: this.form.FK_ID_UTENTE,
				DATA: this.filters.formatDateOnly(this.form.DATA),
				IMPORTO: this.form.IMPORTO,
				DESCRIZIONE: this.form.DESCRIZIONE,
				FK_ID_PROGETTO: this.selectedProgetto,
				FLG_ATTIVO: this.form.FLG_ATTIVO,
				TIPO_MOVIMENTO: this.form.TIPO_MOVIMENTO,
				FK_ID_CATEGORIA: this.form.FK_ID_CATEGORIA || null,
				FILE_ALLEGATO: this.allegatoRawPath || null
			};
			utils.ajax('theb/notaspesa/update', payload, (res) => {
				this.loading = false;
				if (res.esito == 0) {
					this.$emit('saved');
					this.$emit('close');
				} else {
					utils.alert.warning(res.messaggio || 'Errore nell\'associazione');
				}
			});
		},
		skipUpload() {
			this.$emit('saved');
			this.close();
		},
		close() {
			this.$emit('close');
		},
		formatData(data) {
			if (!data) return '';
			const d = new Date(data);
			return d.toLocaleDateString('it-IT');
		}
	}
};
</script>

<style scoped>
.modal {
	z-index: 1050;
}

.modal.show {
	background-color: rgba(0, 0, 0, 0.5);
}
</style>


